namespace $ { export class $piterjs_meetup_snippet extends $mol_link {

	/**
	 *  ```
	 *  arg *
	 *  	meetup <= id
	 *  	speech null
	 *  	now null
	 *  	video null
	 *  	place null
	 *  	others null
	 *  ```
	 **/
	arg() {
		return ({
			"meetup" :  this.id() ,
			"speech" :  null as any ,
			"now" :  null as any ,
			"video" :  null as any ,
			"place" :  null as any ,
			"others" :  null as any ,
		})
	}

	/**
	 *  ```
	 *  id \
	 *  ```
	 **/
	id() {
		return ""
	}

	/**
	 *  ```
	 *  meetup $piterjs_meetup
	 *  ```
	 **/
	@ $mol_mem
	meetup() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_meetup(  ) )
	}

	/**
	 *  ```
	 *  sub /
	 *  	<= Title
	 *  	<= Date
	 *  ```
	 **/
	sub() {
		return [this.Title() , this.Date()] as readonly any[]
	}

	/**
	 *  ```
	 *  Title $mol_view sub / <= title
	 *  ```
	 **/
	@ $mol_mem
	Title() {
		return (( obj )=>{
			obj.sub = () => [this.title()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  title \
	 *  ```
	 **/
	title() {
		return ""
	}

	/**
	 *  ```
	 *  Date $mol_view sub / <= date
	 *  ```
	 **/
	@ $mol_mem
	Date() {
		return (( obj )=>{
			obj.sub = () => [this.date()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  date \
	 *  ```
	 **/
	date() {
		return ""
	}

} }
